function returnBaseUrl() {
    let baseURL = '';
    if (process.env.NODE_ENV === 'development') {
        //本地接口
        // baseURL = 'http://10.10.81.124:8082'
        // baseURL = 'http://10.10.81.144:18081'
    //   baseURL = 'http://10.2.8.64:18081'
    //   baseURL = 'http://www.yomei.cn/ymypapi'
      baseURL = 'http://www.sh-decent9999.com/api'
    } else {

        //线上生产
        // baseURL = 'http://10.10.80.25:18081'
        // baseURL = 'http://10.2.8.64:18081'
        baseURL = 'https://www.yushi9999.com/api'
    }
    return baseURL
}
//MARK:拼接图片地址
function returnImgBaseUrl() {
    let baseURL = returnBaseUrl();
    // let baseURL = 'http://meeting.xxyjewelry.com/meetbackapi'
    return baseURL+"/sys/common/static"
}

module["exports"] = {
    configBaseUrl: returnBaseUrl,
    baseImgUrl:returnImgBaseUrl,
}
